import React, { useState } from 'react';

const MultiSelect = ({ options, selected, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => setIsOpen(!isOpen);

  const handleSelect = (option) => {
    const updatedSelection = selected.includes(option)
      ? selected.filter((item) => item !== option)
      : [...selected, option];
    onChange(updatedSelection);
  };

  return (
    <div className="relative">
      <div
        className="flex cursor-pointer flex-wrap gap-2 rounded-md border p-2"
        onClick={handleToggle}
      >
        {selected.map((item) => (
          <span key={item} className="rounded-md bg-blue-100 px-2 py-1">
            {item}
            <button
              className="ml-2 text-xs"
              onClick={(e) => {
                e.stopPropagation();
                handleSelect(item);
              }}
            >
              ×
            </button>
          </span>
        ))}
        {selected.length === 0 && (
          <span className="text-gray-400">Select options</span>
        )}
      </div>
      {isOpen && (
        <div className="absolute z-10 mt-1 w-full rounded-md border bg-white shadow-lg">
          {options.map((option) => (
            <div
              key={option}
              className={`cursor-pointer p-2 hover:bg-gray-100 ${
                selected.includes(option) ? 'bg-blue-50' : ''
              }`}
              onClick={() => handleSelect(option)}
            >
              <input
                type="checkbox"
                checked={selected.includes(option)}
                onChange={() => {}}
                className="mr-2"
              />
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MultiSelect;
